import { type FC } from 'react';
import { useTranslations } from 'next-intl';

import { AssignedTo } from '@features/assigned_to';
import { EditInn } from '@features/merchant';

import { DecisionBadge } from '@entities/merchant';

import { Box, DateLabel, Flex, Heading } from '@shared/ui-kit';

import { MerchantDecisionState } from '@api/services/merchants';

interface Props {
  merchantId: string;
  name: string;
  tin: string;
  decision: MerchantDecisionState;
  decisionAppliedFullName?: string | null;
  assignedTo: string | null;
  assignedFullName: string | null;
  lastImportedAt: string;
}

const MerchantPageHeader: FC<Props> = (props) => {
  const {
    merchantId,
    name,
    tin,
    decision,
    decisionAppliedFullName,
    assignedTo,
    assignedFullName,
    lastImportedAt,
  } = props;

  const t = useTranslations();

  return (
    <Flex
      direction="column"
      rowGap="6"
    >
      <Flex
        alignItems="center"
        columnGap="9"
      >
        <Heading
          maxWidth="container.md"
          wordBreak="break-word"
          fontSize="3xl"
          className="ym-hide-content"
        >
          {name}
        </Heading>
        <DecisionBadge
          merchant_id={merchantId}
          decision={decision}
          decision_applied_full_name={decisionAppliedFullName}
        />
      </Flex>
      <Flex
        direction="column"
        rowGap="4"
      >
        <Flex
          alignItems="flex-start"
          justifyContent="flex-start"
          columnGap="9"
          data-qa-selector="merchant_subinfo"
        >
          <AssignedTo
            variant="left"
            fontSize="md"
            merchantId={merchantId}
            assignedTo={assignedTo}
            assignedFullName={assignedFullName}
          />
          <EditInn
            merchantId={merchantId}
            merchantTin={tin}
          />
        </Flex>
        <Box w="fit-content">
          <DateLabel
            date={lastImportedAt}
            tooltip={t('Tooltips.lastImportDate')}
          />
        </Box>
      </Flex>
    </Flex>
  );
};

export default MerchantPageHeader;
